import React, { useEffect, useRef, useState } from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import Paper from '@mui/material/Paper';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import type { Dayjs } from 'dayjs';
import './App.css';
import { sendTelegramFormSummary } from './telegram';
import CherryBlossom from './assets/Cherry_Blossom.png';
import HuggingFace from './assets/Hugging_Face.png';
import SmilingFaceWithHeart from './assets/Smiling_Face_With_Hearts.png'

dayjs.extend(localizedFormat);
dayjs.locale('ru');

const DECLINE_FLEE_COUNT = 5;
const DECLINE_RESPAWN_MS = 1000;

const appTheme = createTheme({
  palette: {
    primary: { main: '#fd479c' },
  },
  typography: {
    fontFamily: '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
  },
});

function App() {
  const [declineRemoved, setDeclineRemoved] = useState(false);
  const [declineFleeClass, setDeclineFleeClass] = useState<string | null>(null);
  const respawnTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const [formState, setFormState] = useState(0);
  const [chooseOption, setChooseOption] = useState('');
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
  const [submitting, setSubmitting] = useState(false);
  const [telegramError, setTelegramError] = useState<string | null>(null);

  useEffect(() => {
    return () => {
      if (respawnTimerRef.current !== null) {
        clearTimeout(respawnTimerRef.current);
      }
    };
  }, []);

  const handleDeclineClick = () => {
    if (declineRemoved || declineFleeClass !== null) return;
    const variant = Math.floor(Math.random() * DECLINE_FLEE_COUNT);
    setDeclineFleeClass(`decline-flee-${variant}`);
  };

  const handleDeclineAnimationEnd = (e: React.AnimationEvent<HTMLButtonElement>) => {
    if (!declineFleeClass || !e.animationName.startsWith('decline-flee-')) return;
    setDeclineRemoved(true);
    setDeclineFleeClass(null);

    if (respawnTimerRef.current !== null) {
      clearTimeout(respawnTimerRef.current);
    }
    respawnTimerRef.current = setTimeout(() => {
      setDeclineRemoved(false);
      respawnTimerRef.current = null;
    }, DECLINE_RESPAWN_MS);
  };

  return (
    <ThemeProvider theme={appTheme}>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
        <div className="App">
      <div>
        <img src={CherryBlossom} alt='Cherry Blossom' className='cherry-blossom-top-left cherry-blossom'></img>
        <img src={CherryBlossom} alt='Cherry Blossom' className='cherry-blossom-top-right cherry-blossom'></img>
        <img src={CherryBlossom} alt='Cherry Blossom' className='cherry-blossom-bottom-left cherry-blossom'></img>
        <img src={CherryBlossom} alt='Cherry Blossom' className='cherry-blossom-bottom-right cherry-blossom'></img>
        {
          formState === 0 &&(
            <div className = 'main-content'>
            <img src={HuggingFace} alt='Hugging Face' className='hugging-face'></img>
            <span className = 'invite-text'>Йоу чечик чел печенько уже хуй знает как тебя куда вытащить</span>
            <div className = 'btn-grp'>
              <button className = 'invite-button' onClick={() => setFormState(1)}>Выбрать куда пойти</button>
              <div className="decline-button-slot" aria-hidden={declineRemoved}>
                {!declineRemoved && (
                  <button
                    type="button"
                    className={['decline-button', declineFleeClass].filter(Boolean).join(' ')}
                    onClick={handleDeclineClick}
                    onAnimationEnd={handleDeclineAnimationEnd}
                  >
                    Не
                  </button>
                )}
              </div>
            </div>
          </div>
          )
        } 
        {
          formState === 1 && (
            <div className = 'main-content'>
              <span className = 'invite-text'>Варианты:</span>
              <div className = 'choose-opts'>
              <button className = 'choose-button' onClick={() => {
                  setFormState(3)
                  setChooseOption('дрифт')
                  }}>Дрифт</button>
                <button className = 'choose-button' onClick={() => {
                  setFormState(3)
                  setChooseOption('термы пляж')
                  }}>Термы пляж</button>
                <button className = 'choose-button' onClick={() => {
                  setFormState(3)
                  setChooseOption('боулинг')
                  }}>Боулинг</button>
                <button className = 'choose-button' onClick={() => {
                  setFormState(3)
                  setChooseOption('просто пляж в морском')
                  }}>Просто пляж в морском</button>
                  <button className = 'choose-button' onClick={() => {
                  setFormState(3)
                  setChooseOption('грязный стендап')
                  }}>Грязный стендап</button>
                  <button className = 'choose-button' onClick={() => {
                  setFormState(3)
                  setChooseOption('театр')
                  }}>Театр</button>
                  <button className = 'choose-button' onClick={() => {
                  setFormState(3)
                  setChooseOption('картинг')
                  }}>Картинг</button>
              </div>
            </div>
          )
        }
        {
          formState === 3 && (
            <div className="main-content date-step">
              <span className="invite-text">Выбери дату:</span>
              <Typography sx={{ maxWidth: 320, px: 1, color: 'rgba(0,0,0,0.82)' }}>
                Встреча: <strong>{chooseOption}</strong>
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(0,0,0,0.6)' }}>
                Выбери день в календаре ниже
              </Typography>
              <Paper
                className="date-calendar-wrap"
                elevation={0}
                sx={{
                  borderRadius: 2,
                  bgcolor: 'rgba(255, 254, 254, 0.96)',
                  border: '1px solid rgba(253, 71, 156, 0.25)',
                }}
              >
                <DateCalendar
                  value={selectedDate}
                  onChange={(value) => setSelectedDate(value)}
                  disablePast
                  reduceAnimations
                />
              </Paper>
              <div className="date-step-actions">
                <button
                  type="button"
                  className="invite-button"
                  disabled={!selectedDate || submitting}
                  onClick={async () => {
                    if (!selectedDate) return;
                    setTelegramError(null);
                    setSubmitting(true);
                    const result = await sendTelegramFormSummary({
                      activity: chooseOption,
                      dateLabel: selectedDate.locale('ru').format('D MMMM YYYY'),
                    });
                    setSubmitting(false);
                    if (!result.ok) {
                      setTelegramError(result.error);
                      return;
                    }
                    setFormState(4);
                  }}
                >
                  {submitting ? '…' : 'Готово'}
                </button>
                {telegramError && (
                  <Typography
                    role="alert"
                    sx={{
                      maxWidth: 320,
                      px: 1,
                      fontSize: 13,
                      color: '#b00020',
                    }}
                  >
                    {telegramError}
                  </Typography>
                )}
                <button
                  type="button"
                  className="decline-button"
                  onClick={() => {
                    setTelegramError(null);
                    setFormState(1);
                    setSelectedDate(null);
                  }}
                >
                  Назад
                </button>
              </div>
            </div>
          )
        }
        {
          formState === 4 && (
            <div className = 'main-content'>
              <img src={SmilingFaceWithHeart} className='hugging-face' alt='Smiling Face With Heart'/>
              <span className="invite-text">До встречи!</span>
            </div>
          )
        }
      </div>
    </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

export default App;
